/**
 * =====================================
 * File: FooterBar.js
 * Component: FooterBar
 * Purpose: Create a page footer with information
 *  about page versioning and with links to useful
 *  external sites
 * Author: Noah Fultz
 * Date: 2026-06-13
 * =====================================
 */

import { useState, useEffect } from 'react';


import './FooterBar.css';


function FooterBar({ access_level = 'PUBLIC' }) {
	const [version, setVersion] = useState('v0.0.0');

	useEffect(() => {
		fetch(`${process.env.REACT_APP_API_BASE_URL}/version`)
			.then(res => res.json())
			.then(data => setVersion(data.semantic_version));
	}, []);

	return (
		<footer id='footer-sect'>
			<p id='footer-topsect'>
				<em className='footer-em'>BSA&nbsp;Troop&nbsp;312</em> website&nbsp;{version}
			</p>

			<div id='footer-bodysect'>
				{access_level.toUpperCase() === 'PUBLIC' &&
					<div className='footer-sidesect' id='footer-leftsect'>
						<p className='footer-textrow'>
							Interested? Visit us on Tuesdays at 7:00pm at 1110 Kinley Rd, Irmo SC
						</p>
					</div>
				}

				<nav className='footer-sidesect' id='footer-rightsect' aria-label='Helpful links'>
					<p className='footer-textrow'>
						<a 
							className='footer-link' 
							href='https://my.scouting.org'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='My Scouting (opens in new tab)'
						>My Scouting</a> - The official web portal for
						adult volunteers, leaders, and parents in Scouting
						America
					</p>

					<p className='footer-textrow'>
						<a 
							className='footer-link' 
							href='https://www.sssjirmo.org'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='St. Simon & St. Jude Episcopal Church website (opens in new tab)'
						>SSSJ Website</a> - The website of our sponsor, St. Simon
						&amp; St. Jude Episcopal Church
					</p>

					<p className='footer-textrow'>
						<a 
							className='footer-link' 
							href='https://www.scouting.org'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='Scouting America (opens in new tab)'
						>Scouting America</a> - The official website of Scouting America
					</p>
				</nav>
			</div>

			<div id='footer-bottomsect'>
				<p>
					For any issues or suggestions for the site, please send an email to{' '}
					<a 
						href='mailto:noah.fultz314@gmail.com'
						className='footer-link'
						aria-label='Email Noah Fultz at noah.fultz314@gmail.com'
					>noah.fultz314@gmail.com</a>
				</p>
			</div>
		</footer>
	);
}


export default FooterBar;